var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-curvey"},[_c('h2',[_vm._v("Campaigns")]),_c('apex-chart',{attrs:{"type":"bar","options":_vm.options,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }